import * as React from 'react';

import classnames from 'classnames';

import {Button} from 'shells/button/button';
import type {ButtonVariant} from 'shells/button/types';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import type {LoginVariant} from '../login-page';

import styles from '../login-form.module.css';

type Props = {
    bttnVariant: ButtonVariant;
    submitting?: boolean;
    onClick?: () => void;
    children?: React.ReactNode;
    pageVariant?: LoginVariant;
};

export function LoginFlowButton(props: Props) {
    const loginCopy = props.submitting ? 'Logging in...' : 'Log in';
    const continueCopy = props.submitting ? 'Finding user...' : 'Continue';

    return (
        <div className={classnames(styles.button, styles.submit)}>
            <Button
                variant={props.bttnVariant}
                type='submit'
                size='xlarge'
                disabled={props.submitting}
                isFullWidth={true}
                onClick={props.onClick}
            >
                <div className='flex full-width full-height align-center justify-center gap-8'>
                    {props.children ? (
                        props.children
                    ) : (
                        <>
                            {props.pageVariant === 'sign-in' ? continueCopy : loginCopy}
                            {props.submitting && (
                                <div>
                                    <LoadingIcon fill={colors.white} size={29} />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Button>
        </div>
    );
}
